module.exports = __webpack_public_path__ + "img/8.1aeede33.png";